module.exports = __webpack_public_path__ + "static/img/macOS_FAQ_pic15.d593f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/macOS_FAQ/macOS_FAQ_pic15.png
// module id = 514
// module chunks = 1